import DialogBox from './DialogBox.vue';

export default DialogBox;
